import httpClient from '@/api/httpClient'
import { defineStore } from 'pinia'
import store from '@/store'

export const useStyleMapsStore = defineStore('styleMaps', {
  state: () => ({
    styleMaps: [],
    fetchInitiated: false,
  }),

  getters: {
    forId: ({ styleMaps }) => (id) => {
      return styleMaps.find(styleMap => styleMap.id === id)
    },
  },

  actions: {
    async fetch() {
      this.fetchInitiated = true

      return httpClient.get('/api/internal/style_maps')
        .then(response => {
          this.styleMaps = response.data.style_maps
        })
        .catch((err) => {
          store.dispatch('messages/smartAdd', err)
        })
    },

    async create(styleMap) {
      return httpClient.post(
        '/api/internal/style_maps',
        { style_map: styleMap }
      ).then(response => {
        this.styleMaps.push(response.data.style_map)
        return response
      }).catch((err) => {
        store.dispatch('messages/smartAdd', err)
      })
    },

    async update(styleMap) {
      return httpClient.patch(
        `/api/internal/style_maps/${styleMap.id}`,
        { style_map: styleMap }
      ).then(response => {
        this.styleMaps = this.styleMaps.map(sMap => {
          return sMap.id === styleMap.id ? response.data.style_map : sMap
        })
        return response
      }).catch((err) => {
        store.dispatch('messages/smartAdd', err)
      })
    },

    async delete(styleMapId) {
      return httpClient.delete(
        `/api/internal/style_maps/${styleMapId}`
      ).then(response => {
        this.styleMaps = this.styleMaps.filter(sMap => sMap.id !== styleMapId)
        return response
      }).catch((err) => {
        store.dispatch('messages/smartAdd', err)
      })
    },

    async fetchOnce() {
      if (this.fetchInitiated) return Promise.resolve()

      return this.fetch()
    },
  },
})
